import React, { useState } from 'react';
import { Wrench, BookOpen } from 'lucide-react';
import StarField from './StarField';
import ImageLightbox from './ImageLightbox';

const WatchesSection = () => {
  const [lightboxImage, setLightboxImage] = useState(null);
  const watches = [
    {
      name: 'MM300 "Night Wing" Mod',
      description: 'My first advanced build featuring blue luminous accents on various parts',
      features: ['Blue Lume', 'Leather Strap', 'Modified Movement'],
      image: 'https://customer-assets.emergentagent.com/job_santiago-timepieces/artifacts/i15y4w0n_mm300%20pic.png',
    },
    {
      name: 'Seiko Dress Watch Mod',
      description: 'Elegant dress watch modification with classic styling',
      features: ['Classic Design', 'Stainless Steel', 'Modified Dial'],
      image: 'https://customer-assets.emergentagent.com/job_santiago-timepieces/artifacts/ayylmkh0_seiko%20dress%20mod.png',
    },
    {
      name: '"Coffee" Daytona Chronograph Mod',
      description: 'My first mechanical-quartz build featuring a timer hand that automatically resets after an hour',
      features: ['Chronograph Function', 'Leather/Suede Strap', 'Unique Color Combo'],
      image: 'https://customer-assets.emergentagent.com/job_santiago-timepieces/artifacts/8jxi55x0_coffee%20chronograph%20pic.png',
    },
    {
      name: '"Buddha Samurai" Mod',
      description: 'A spiritual east-meets-warrior build with a compass bezel and dorjee dial centerpiece',
      features: ['Samurai Case', 'Dorjee Dial', 'Mechanical Quartz Movement', 'Compass Bezel Insert'],
      image: 'https://customer-assets.emergentagent.com/job_santiago-timepieces/artifacts/xcd13c56_Buddha%20Samurai%20Image%20edit.jpg',
    },
  ];

  return (
    <section id="watches" className="py-24 bg-black relative overflow-hidden">
      <StarField density="sparse" />
      <div className="container mx-auto px-6 max-w-6xl relative z-10">
        {/* Section Header */}
        <div className="mb-16">
          <h2 className="text-4xl md:text-5xl font-light text-white mb-4 tracking-tight">
            Featured Builds
          </h2>
          <div className="w-20 h-1 bg-white"></div>
          <p className="text-gray-400 font-light mt-4">
            Explore some of my custom mechanical watch builds
          </p>
        </div>

        {/* Watches Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {watches.map((watch, index) => (
            <div
              key={index}
              className="bg-white/5 backdrop-blur-sm border border-white/10 p-8 hover:bg-white/10 hover:border-white/30 hover:shadow-[0_0_40px_rgba(255,255,255,0.15)] hover:-translate-y-1 transition-all duration-300 group"
            >
              <div className="aspect-square bg-white/5 mb-6 flex items-center justify-center group-hover:bg-white/10 transition-colors duration-300 overflow-hidden">
                <img
                  src={watch.image}
                  alt={watch.name}
                  onClick={() => setLightboxImage({ src: watch.image, alt: watch.name })}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300 cursor-zoom-in"
                />
              </div>
              <h3 className="text-xl font-medium text-white mb-3">{watch.name}</h3>
              <p className="text-gray-400 font-light text-sm mb-4">{watch.description}</p>
              <div className="space-y-2">
                {watch.features.map((feature, idx) => (
                  <div key={idx} className="text-xs text-gray-500 flex items-center">
                    <span className="w-1 h-1 bg-white/40 rounded-full mr-2"></span>
                    {feature}
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>

      <ImageLightbox
        src={lightboxImage?.src}
        alt={lightboxImage?.alt}
        isOpen={!!lightboxImage}
        onClose={() => setLightboxImage(null)}
      />
    </section>
  );
};

export default WatchesSection;
